<template>
    <div>
      <notifications></notifications>
  
      <base-header class="pb-6 pb-1 pt-5 pt-md-8 bg-gradient-custom" type="custom"></base-header>
  
    <!-- Formulario -->
    <b-container fluid class="mt--6">
        <b-card>
          <b-card-body>
        <form @submit.prevent="ingesarPLAN">
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label">ID:</label>
            <b-col md="10">
              <base-input v-model="datosidPlan" placeholder="Ingrese ID" required />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label">ICCID:</label>
            <b-col md="10">
              <base-input v-model="datosICCIDplan" placeholder="Ingrese ICCID" required />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label">PRECIO:</label>
            <b-col md="10">
              <base-input v-model="datosprecioPlan" type="number" placeholder="Ingrese Precio" />
            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label">TIPO:</label>
            <b-col md="10">
              <base-input>
                <select class="form-control" v-model="datosanualmensualPlan" required>
                  <option>Mensual</option>
                  <option>Anual</option>
                  <option>Ilimitado</option>
                </select>
              </base-input>

            </b-col>
          </b-row>
          <b-row class="form-group">
            <label class="col-md-2 col-form-label form-control-label">Cantidad de :</label>
            <b-col md="10">
              <base-input v-model="datosdataprometidaPlan" placeholder="Ingrese Data Prometida" />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <base-button type="success" @click="modificarDatosPLAN" :loading="isLoading">
                {{ isLoading ? 'Guardando...' : 'Guardar' }}
              </base-button>
              <base-button type="warning" @click="$router.push('/Plan')">Cancelar</base-button>
            </b-col>
          </b-row>
        </form>
      </b-card-body>
      </b-card>
    </b-container>
    <token-expired-modal :show="showTokenExpiredModal"> </token-expired-modal>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import Card from '../components/Cards/Card.vue';
  import BaseButton from '../components/BaseButton.vue';
  import BaseInput from '../components/Inputs/BaseInput.vue';
import TokenExpiredModal from '../components/TokenExpiredModal.vue';
  
  export default {
    components: { Card, BaseButton, BaseInput, TokenExpiredModal },
    data() {
      return {
        datosidPlan: "", // ID del plan
        datosICCIDplan: "", // ICCID del plan
        datosprecioPlan: "", // Precio del plan
        datosanualmensualPlan: "", // Anual/Mensual del plan
        datosdataprometidaPlan: "", // Data Prometida del plan
        showTokenExpiredModal:false,
        isLoading: false, // Estado de carga
      };
    },
    mounted() {
      this.fetchPlanData(); // Cargar datos al montar el componente
    },
    methods: {
      // Obtener los datos del plan
      async fetchPlanData() {
        this.isLoading = true;
        try {
          const token = localStorage.getItem("token");
          const id = this.$route.params.id; // Obtener el ID de la ruta
          const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/obtenerDatosPlan/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          if (response.data.success && response.data.data) {
            const planData = response.data.data;
            this.datosidPlan = planData.ID_PLAN; // Asignar el ID
            this.datosICCIDplan = planData.ICCID; // Asignar el ICCID
            this.datosprecioPlan = planData.PRECIO; // Asignar el precio
            this.datosanualmensualPlan = planData.ANUAL_MENSUAL; // Asignar Anual/Mensual
            this.datosdataprometidaPlan = planData.DATA_PROMETIDA; // Asignar Data Prometida
          } else {
            this.$notifications.addNotification({
              type: 'danger', // Tipo de notificación (error)
              message: 'Error al obtener los datos del plan.',
            });
          }
        } catch (error) {
          console.error("Error al obtener los datos:", error);
          this.$notifications.addNotification({
            type: 'danger', // Tipo de notificación (error)
            message: 'Error al obtener los datos del plan.',
          });
        } finally {
          this.isLoading = false;
        }
      },
  
      // Modificar los datos del plan
      async modificarDatosPLAN() {
        this.isLoading = true;
        const token = localStorage.getItem("token");
  
        if (!this.checkToken()) {
          this.$notifications.addNotification({
            type: 'danger', // Tipo de notificación (error)
            message: 'Token no presente. Usuario no autenticado.',
          });
          this.isLoading = false;
          return;
        }
  
        const datos = {
          ICCID: this.datosICCIDplan, // ICCID actualizado
          PRECIO: this.datosprecioPlan, // Precio actualizado
          ANUALMENSUAL: this.datosanualmensualPlan, // Anual/Mensual actualizado
          DATAPROMETIDA: this.datosdataprometidaPlan, // Data Prometida actualizada
        };
  
        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API_URL}/modificarDatosPLAN/${this.datosidPlan}`,
            datos,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          if (response.data.success) {
            this.$notifications.addNotification({
              type: 'success', // Tipo de notificación (éxito)
              message: 'Datos modificados correctamente',
            });
            this.$router.push('/Plan'); // Redirigir después de la modificación
          } else {
            this.$notifications.addNotification({
              type: 'danger', // Tipo de notificación (error)
              message: response.data.message || 'Error al modificar los datos',
            });
          }
        } catch (error) {
          console.error("Error al modificar los datos:", error);
          this.$notifications.addNotification({
            type: 'danger', // Tipo de notificación (error)
            message: 'Error al modificar los datos',
          });
        } finally {
          this.isLoading = false;
        }
      },
      handleTokenExpired() {
        this.showTokenExpiredModal = true;
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      },
  
      // Verificar si el token está presente
      checkToken() {
        return localStorage.getItem("token") !== null;
      },
    },
  };
  </script>